import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

export default class Timeline extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        children: PropTypes.array.isRequired,
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render () {
        const { children }  = this.props;

        return (
            <div className="submission-status-timeline-row">
                <ul className="submission-status-timeline">
                    {children}
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Timeline/Timeline.jsx